import { useEffect, useMemo } from 'react';
import SettlementTable from '../../Tables/settlement/SettlementTable';
import { productSettlementColumns } from '../../../features/purchases/settlement/settlementColumns';
import ProductInfoCard from './ProductInfoCard';
import SettlementStatusCard from './SettlementStatusCard';
import ProductSettlementFormCard from './ProductSettlementFormCard';
import { useBranch } from '../../../hooks/branches/useBranch';
import { useProductSettlement } from '../../../hooks/settlement/useProductSettlement';
import { useBasePurchase } from '../../../hooks/purchases/useBasePurchase';

const ProductSettlementView = () => {
  const columns = useMemo(() => productSettlementColumns, []);
  const { fetchBranchDropdown, branchDropdown } = useBranch();
  const {
    settlementSummary,
    handlerSettleProduct,
    handlerDeleteSettlement, // ✅ nuevo handler integrado
  } = useProductSettlement();
  const { form } = useBasePurchase();

  useEffect(() => {
    fetchBranchDropdown();
  }, []);

  const handleManualSettle = (branchId: number, quantity: number) => {
    if (!form?.id || !settlementSummary?.product?.id) {
      console.warn('❌ Faltan datos necesarios para asentar.');
      return;
    }

    const dto = {
      purchaseId: form.id,
      productId: settlementSummary.product.id,
      branchId,
      quantity,
    };

    handlerSettleProduct(dto);
  };

  const actions = useMemo(() => {
    return [
      {
        key: 'delete',
        onClick: (row: any) => {
          if (!form?.id || !settlementSummary?.product?.id) {
            console.warn('❌ No se puede eliminar: falta ID de compra o producto.');
            return;
          }

          handlerDeleteSettlement(
            form.id,
            settlementSummary.product.id,
            row.branchId
          );
        },
      },
    ];
  }, [form.id, settlementSummary?.product?.id]);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <ProductInfoCard productInfo={settlementSummary?.product} />
        <SettlementStatusCard status={settlementSummary?.status} />
        <ProductSettlementFormCard
          branches={branchDropdown}
          onSettle={handleManualSettle}
        />
      </div>

      <SettlementTable
        title="Asentamientos por Sucursal"
        columns={columns}
        data={settlementSummary?.details || []}
        actions={actions}
        showFilters
        noDataMessage="No hay asentamientos registrados."
      />
    </div>
  );
};

export default ProductSettlementView;
